import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import { IGeneralResponse } from '@/api/types'

export interface ICountryAttributes {
  name: string
  iso: string
  tier: number
  is_eu: boolean
  with_zip: boolean
}

export interface ICountry {
  id: string
  type: 'country'
  attributes: ICountryAttributes
}

export interface ICountriesResponse extends IGeneralResponse {
  data: Array<ICountry>
}

export const fetchItems = async (): Promise<ICountriesResponse> => {
  const params = Object.assign(
    { limit: 400, start: 0 },
    nestedQueryFormatter('sorter', { direction: 'asc', field: 'name' })
  )

  const response = await apiClient.get<ICountriesResponse>('/countries', {
    params
  })
  return response.data
}
